export {default as color, rgb, hsl} from "./src/color";
export {default as lab, hcl} from "./src/lab";
export {default as cubehelix} from "./src/cubehelix";



//////////////////
// WEBPACK FOOTER
// ./~/d3-color/index.js
// module id = 4
// module chunks = 0